import UpIcon from '@mui/icons-material/KeyboardArrowUp';
import Fab from '@mui/material/Fab';
import { useState, useEffect } from 'react';

import { scrollBackToTop } from '@/utils/scrollBackToTop';

import { scrollUpButtonStyles as sx } from './ScrollUpButton.styles';

const NAVBAR_HEIGHT = 70;

export const ScrollUpButton = () => {
	const [visible, setVisible] = useState(false);

	const toggleVisible = () => {
		const scrolled = document.documentElement.scrollTop;
		setVisible(scrolled > NAVBAR_HEIGHT);
	};

	useEffect(() => {
		window.addEventListener('scroll', toggleVisible);

		return () => {
			window.removeEventListener('scroll', toggleVisible);
		};
	}, []);

	const scrollToTop = () => {
		scrollBackToTop();
	};

	if (!visible) {
		return null;
	}

	return (
		<Fab
			onClick={scrollToTop}
			sx={sx.root}
			size='small'
			color='primary'
			id='scroll-up-button'
		>
			<UpIcon sx={sx.icon} />
		</Fab>
	);
};
